import { getRole } from '@adjust/dashboard-core/lib/utils/user';
import { User, UserRole } from '@adjust/dashboard-core/api/types';

export const getUsersGroupedByRole = (users: User[]) =>
  users.reduce((result: { [role in UserRole]?: User[] }, user: User) => {
    const role = getRole(user);

    const roles = result[role];
    if (roles) {
      roles.push(user);
    } else {
      result[role] = [user];
    }

    return result;
  }, {});
